<template>
  <div
    :aria-label="title"
    :hidden="!active"
    :id="id"
    :tabindex="active ? 0 : -1"
    class="nr-tabs__tab"
    role="tabpanel"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { uniqueId } from 'lodash'
const COMPONENT_NAME = 'nr-tab'

export interface Tab {
  title: string
  id: string
}

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    // A unique `id` can optionally be provided. This will be emitted by `NrTabs` on the `update:activeTabId` event when the tab is selected.
    id: {
      type: String,
      required: false,
      default: () => uniqueId(`${COMPONENT_NAME}-`)
    }
  },
  inject: ['registerTab', 'activeTabId'],
  mounted() {
    const tab: Tab = { title: this.title, id: this.id }
    this.registerTab(tab)
  },
  computed: {
    active() {
      return this.activeTabId() === this.id
    }
  }
}
</script>

<style scoped lang="scss">
.nr-tabs__tab {
  padding: 1rem;
}
</style>
